import { REHYDRATE } from 'redux-persist';

export default (state = null, action) => {
    switch (action.type) {
        case REHYDRATE:
            return true;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/app.js